import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { FormattedPeriod } from '../../components/overviewTable/FormattedPeriod';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ForecastCellTooltip = ({
  children,
  fiscalOffset,
  isTeamRow,
  isTotalRow,
  name,
  rollupAmount,
  teamSubmissionAmount,
  timePeriod
}) => /*#__PURE__*/_jsx(Tooltip, {
  disabled: !isTeamRow,
  placement: "left",
  headingText: /*#__PURE__*/_jsxs(_Fragment, {
    children: [name, ' ', /*#__PURE__*/_jsx(FormattedMessage, {
      message: "repOverviewTable.forecastCell.tooltip.title"
    })]
  }),
  title: /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      marginBlockEnd: "100",
      children: [/*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "repOverviewTable.forecastCell.tooltip.timePeriod"
        })
      }), /*#__PURE__*/_jsx(Box, {
        marginInlineStart: "500",
        children: /*#__PURE__*/_jsx(FormattedPeriod, {
          timePeriod: timePeriod,
          offset: fiscalOffset
        })
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      marginBlockEnd: "100",
      children: [/*#__PURE__*/_jsx(Box, {
        children: isTotalRow ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "repOverviewTable.forecastCell.tooltip.columnTotal"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "repOverviewTable.forecastCell.tooltip.total"
        })
      }), /*#__PURE__*/_jsx(Box, {
        marginInlineStart: "500",
        "data-test-id": "tooltip-rollup-submission-amount",
        children: rollupAmount !== null && rollupAmount !== void 0 && rollupAmount.value ? /*#__PURE__*/_jsx(FormattedIntlCurrency, {
          value: rollupAmount.value,
          currencyCode: rollupAmount.currencyCode
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "repOverviewTable.forecastCell.tooltip.notAvailable"
        })
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "repOverviewTable.forecastCell.tooltip.teamSubmission"
        })
      }), /*#__PURE__*/_jsx(Box, {
        marginInlineStart: "500",
        "data-test-id": "tooltip-team-submission-amount",
        children: teamSubmissionAmount !== null && teamSubmissionAmount !== void 0 && teamSubmissionAmount.value ? /*#__PURE__*/_jsx(FormattedIntlCurrency, {
          value: teamSubmissionAmount.value,
          currencyCode: teamSubmissionAmount.currencyCode
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "repOverviewTable.forecastCell.tooltip.notAvailable"
        })
      })]
    })]
  }),
  children: /*#__PURE__*/_jsx(_Fragment, {
    children: children
  })
});
export default ForecastCellTooltip;